import {Order} from "../../types";
import Decimal from 'decimal.js';
import {getTotal} from './getTotal';
import {getPaymentsTotal} from './getPaymentsTotal';

export const getRemainingBalance = (order: Order): string => {
    const total = new Decimal(getTotal(order));
    const paymentsTotal = new Decimal(getPaymentsTotal(order));
    return total.sub(paymentsTotal).toFixed(2);
}